import { render, staticRenderFns } from "./SoloCard.vue?vue&type=template&id=ab2ad732&scoped=true&"
import script from "./SoloCard.vue?vue&type=script&lang=js&"
export * from "./SoloCard.vue?vue&type=script&lang=js&"
import style0 from "./SoloCard.vue?vue&type=style&index=0&id=ab2ad732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2ad732",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SoloCard.vue
// module id = null
// module chunks = 